<tcc-simplePanel [size]="panalSize" [buttons]="['close']" (buttonClick)="close()">

    <div panel-header *ngIf="state === 'ready'">
        Management Fees list

        <div style="float: right; text-align: center;">
            <small>                                
                <label>Download (csv)</label>
            </small>
            <br />
            <a (click)="downloadReport()">
                <small>                                
                    <i class="fa fa-fw fa-download"></i>
                </small>                
            </a>
        </div>

    </div>

    <div panel-body *ngIf="state === 'ready'">

        <div *ngIf="state === 'ready'" class="tcc-table-div">
            <tcc-table tableClass="table-sm small" [rows]="allSplits" [columns]="columns"
                (cellClick)="rowClicked($event)">
            </tcc-table>
        </div>
    </div>
</tcc-simplePanel>